/**
 * IconBadge — Small icon container with tinted background
 *
 * Variants:
 *   - variant: muted (default), solid
 *   - size: sm (32), md (40)
 *
 * Used for: icon wrappers in StatCard, ActionCard, ListItem, step badges, etc.
 */
import { styled, XStack } from 'tamagui'

export const IconBadge = styled(XStack, {
  name: 'IconBadge',
  ai: 'center',
  jc: 'center',

  variants: {
    variant: {
      muted: { bg: '$colorPrimaryMuted' },
      solid: { bg: '$colorPrimary' },
    },
    size: {
      sm: { w: 32, h: 32, br: '$sm' },
      md: { w: 40, h: 40, br: '$lg' },
    },
  } as const,

  defaultVariants: {
    variant: 'muted',
    size: 'md',
  },
})
